<div class="tdo-dropdown-menu" matTooltip="{{tooltip}}" data-cy="tdo-notes-multiselect-menu-container">
  <button mat-icon-button style="width: 25px; height: 25px;" [matMenuTriggerFor]="menu" data-cy="tdo-notes-multiselect-menu-trigger">
    <lucide-icon name="chevron-down" [size]="20"></lucide-icon>
  </button>

  <!-- Menu using Angular Material -->
  <mat-menu #menu="matMenu">
    @if (type === 'category') {
      <div [style.max-height]="maxHeight + 'px'" class="menu-content" data-cy="tdo-notes-multiselect-menu-category-content" (click)="$event.stopPropagation()">
        <!-- Select All Option -->
        @if (isShowAllSelectors) {
          <mat-checkbox (change)="onAllCategoriesClick($event)" data-cy="tdo-notes-multiselect-menu-select-all-categories">
            Select All
          </mat-checkbox>
        }
        <!-- Category Items -->
        <mat-list data-cy="tdo-notes-multiselect-menu-category-list">
          @for (item of selectableItems; track item) {
            <mat-list-item data-cy="tdo-notes-multiselect-menu-category-item">
              <mat-checkbox [checked]="isCategorySelected(item)" (change)="onCategoryClicked(item)" data-cy="tdo-notes-multiselect-menu-category-checkbox">
                <!-- Checkbox only -->
              </mat-checkbox>
              <span data-cy="tdo-notes-multiselect-menu-category-label">{{ item.ItemDisplayValue }}</span> <!-- Text outside checkbox -->
            </mat-list-item>
          }
        </mat-list>
      </div>
    }

    @if (type === 'type') {
      <div [style.max-height]="maxHeight + 'px'" class="menu-content" data-cy="tdo-notes-multiselect-menu-type-content" (click)="$event.stopPropagation()">
        <!-- Select All Option for Types -->
        @if (isShowAllSelectors) {
          <mat-checkbox (change)="onAllTypesClick($event)" data-cy="tdo-notes-multiselect-menu-select-all-types">
            Select All
          </mat-checkbox>
        }
        <!-- Type Items -->
        <mat-list data-cy="tdo-notes-multiselect-menu-type-list">
          @for (item of selectableItems; track item) {
            <mat-list-item data-cy="tdo-notes-multiselect-menu-type-item">
              <mat-checkbox [checked]="isTypeSelected(item)" (change)="onTypeClicked(item)" data-cy="tdo-notes-multiselect-menu-type-checkbox">
                <!-- Checkbox only -->
              </mat-checkbox>
              <span data-cy="tdo-notes-multiselect-menu-type-label">{{ item.ItemDisplayValue }}</span> <!-- Text outside checkbox -->
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </mat-menu>
</div>